import {useRef, useState, useCallback} from 'react';

export function useWakeLock(onRequest, onError, onRelease) 
{
	const [released, setReleased] = useState(true);
	const wakeLock = useRef(null);

	// https://caniuse.com/mdn-api_wakelock
	const isSupported = 'wakeLock' in navigator;

	const request = useCallback(
		async (type) => {
			const isWakeLockAlreadyDefined = wakeLock.current != null;

// 			console.log('request');

			if (!isSupported) {
				console.warn("Calling the `request` function has no effect, Wake Lock Screen API isn't supported");
				return;
			} else if (isWakeLockAlreadyDefined) {
				console.warn('Calling `request` multiple times without `release` has no effect');
				return;
			}

			try {
				wakeLock.current = await navigator.wakeLock.request(type);
				wakeLock.current.onrelease = (e) => {
					// Default to `true` - `released` API is experimental: https://caniuse.com/mdn-api_wakelocksentinel_released
					setReleased((wakeLock.current && wakeLock.current.released) ? true : false);
					onRelease(e);
					wakeLock.current = null;
				};

				onRequest();
				setReleased((wakeLock.current && wakeLock.current.released) ? true : false);
			} catch (error) {
				onError && onError(error);
			}
		}, 
		[isSupported, onRequest, onError, onRelease]
	);

	const release = useCallback(
		async () => {
			const isWakeLockUndefined = wakeLock.current == null;
			
// 			console.log('release');

			if (!isSupported) {
				console.warn("Calling the `release` function has no effect, Wake Lock Screen API isn't supported");
				return;
			}

			if (isWakeLockUndefined) {
				console.warn('Calling `release` before `request` has no effect.');
				return;
			}

			wakeLock.current && (await wakeLock.current.release());
		}, 
		[isSupported]
	);

	return {
		isSupported,
		released,
		request,
		release
	};
};
